//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Null from 'components/blocks/Null.vue'
import Toc from 'components/combinedBlocks/Toc.vue'

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'currentSection',
      'sections'
    ])
  },
  components: {
    Toc,
    Null,
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/FixedSections.vue